export default {
  common: {
    casino: "カジノ",
    more: "もっと見る",
    searchGames: "ゲームを検索",
    copied: "コピーしました！",
    inputTooLong: "入力内容が長すぎます。もう一度入力してください。",
    inputNameCn: "中国語、英字、数字、アンダースコアのみ入力できます",
    inputCapital: "大文字とアンダースコアのみ入力できます",
    inputLowercaseUnderscore: "小文字とアンダースコアのみ入力できます",
    inputLowercase: "小文字のみ入力できます",
    inputNoSpace: "空白のみの入力はできません",
    inputValidPhone: "有効な電話番号を入力してください",
    inputNonNumber: "数字以外の文字が含まれています",
    inputNonLetter: "文字以外が含まれています",
    inputLetterOrNumberOnly: "英字または数字のみ入力できます",
    phoneFormatError: "電話番号の形式が正しくありません",
    inputLetterStartNumber: "英字で始まり、数字を含めることができます",
    inputNoChinese: "中国語の文字は入力できません",
    inputChineseOnly: "中国語の文字のみ入力できます",
    emailFormatError: "メールアドレスの形式が正しくありません",
    urlFormatError: "URLの形式が正しくありません",
    jsonFormatError: "JSONの形式が正しくありません",
    networkError: "サーバーに接続できませんでした。後でもう一度お試しください。",
    siteUnavailable: "このサイトは現在利用できません。管理者にお問い合わせください。",
    tokenExpired: "セッションの有効期限が切れました。再度ログインしてください。",
    domainNotAuthorized: "ドメインが承認されていません",
    demoEnvOnly: "デモ環境、プレビュー専用です",
    passwordLength630: "6〜30文字",
    newPasswordSameAsOld: "新しいパスワードは古いパスワードと同じにできません",
    confirmNewPassword: "新しいパスワードを確認してください",
    passwordsDoNotMatch: "パスワードが一致しません",
    withdrawPasswordChanged: "出金パスワードを変更しました",
    withdrawPasswordSet: "出金パスワードを設定しました",
    withdrawPasswordSetFailed: "出金パスワードの設定に失敗しました",
    phoneDigitsOnly: "電話番号は数字のみで入力してください",
    phoneTooShort: "電話番号が短すぎます（最小{min}桁）",
    phoneTooLong: "電話番号が長すぎます（最大{max}桁）",
    phoneInvalidPrefix: "電話番号のプレフィックスが無効です",
    rolloverAll: "すべての種類",
    rolloverAllStats: "すべてのステータス",
    rolloverSuccessful: "成功",
    rolloverFailed: "失敗",
    rolloverInProgress: "進行中",
    rolloverSuccess: "成功",
    rolloverPending: "保留中",
    rolloverCompleted: "完了",
    rolloverCancelled: "キャンセル済み",
    rolloverExpired: "期限切れ",
    walletCash: "現金",
    walletBonus: "ボーナス",
    sourceDeposit: "入金",
    sourceCommission: "コミッション",
    sourceManualAdd: "手動追加",
    sourceManualSubtract: "手動減算",
  },
  redeemCode: {
    enterTip: "引き換えコードを入力して報酬を受け取る",
    placeholder: "コードを入力してください",
    redeemBtn: "引き換え",
    pleaseEnterCode: "引き換えコードを入力してください",
    redeemSuccess: "引き換え成功！",
    redeemFailed: "引き換え失敗、もう一度お試しください",
  },
}
